import {PriceBoxProps} from '@/_application/modules/products/components/price/price.types';
import cn from 'classnames';
import {useCalculatePrices} from '../calculate-prices';
import DiscountSimple from './discount-simple';

const classes = {
    root: 'original-price font-bold text-KPZ_Orange!',
    baseText: 'text-base',
    mediumText: 'text-xl md:text-base',
    smallText: 'text-sm',
    extraLargeText: 'text-[22px] md:text-xl',
    details: 'text-lg text-white md:text-[32px] md:leading-[36px] md:text-KPZ_Orange',
};

export const FinalPriceSimple = ({
    product,
    //size = 'medium',
    variant,
    useBasePrice = false,
    priceClassName,
    flashSaleDealPrice,
}: PriceBoxProps) => {
    let {maximumPrice, minimumPrice, minPrice, maxPrice, discount, basePrice, price} = useCalculatePrices(product, flashSaleDealPrice);

    if (useBasePrice && basePrice) {
        //handle case product is flashsale but is out of stock => use base price
        price = basePrice;
        basePrice = null;
    }

    let textSize;
    switch (variant) {
        case 'horizontal':
            textSize = [classes.extraLargeText];
            break;
        case 'details':
            textSize = [classes.details];
            break;
        default:
            textSize = [classes.mediumText];
            break;
    }

    // switch (size) {
    //   case 'small':
    //     textSize = [classes.smallText];
    //     break;
    //   case 'extra-large':
    //     textSize = [classes.extraLargeText];
    //     break;
    //   default:
    //     textSize = [classes.mediumText];
    //     break;
    // }
    const priceClasses = cn(classes.root, textSize, priceClassName);

    return (
        <div
            className={cn('block min-h-11 items-center justify-between', {
                'bg-orange-yellow-gradient px-4 py-2 md:bg-none md:px-0 md:py-0': variant === 'details',
            })}>
            {maximumPrice.value! != minimumPrice.value! ? (
                <>
                    <p
                        className={cn('text-sm font-bold  md:text-base', {
                            'text-KPZ_Orange': variant !== 'details',
                            'text-lg text-white! md:text-[32px]! md:leading-[36px]! md:text-KPZ_Orange!':
                                variant === 'details',
                        })}>
                        <span>{minPrice}</span>
                        <span> - </span>
                        <span>{maxPrice}</span>
                    </p>

                    {discount && basePrice && <DiscountSimple basePrice={basePrice} price={price} variant={variant} />}
                </>
            ) : (
                <>
                    <p className={priceClasses}>{price}</p>
                    {discount && basePrice && <DiscountSimple basePrice={basePrice} price={price} variant={variant} />}
                </>
            )}
        </div>
    );
};
